import React from 'react';
import { pdf, Font, Document, Page, Text, Image,View, StyleSheet } from '@react-pdf/renderer';
import HelveticaBold from '../../../../assets/Fonts/HelveticaNeueLTGEOW82-75Bd.ttf'; 
import HelveticaRd from '../../../../assets/Fonts/HelveticaNeueLTGEOW82-55Rm.ttf'; 
import FontLetter from '../../../../assets/Fonts/blfont.ttf';  
import AigLogo from '../../../../assets/Logo/AigText.png';
import Signature from '../../../../assets/Logo/Signature.png'; 
import FileDollar from "../../../../assets/Icon/FileDollar";


const formatDate = (dateString) => {

   // const purchasedAtDate = new Date(dateString);
    const purchasedAtDate = new Date();

    const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ];
     
    const day = purchasedAtDate.getDate();
    const month = months[purchasedAtDate.getMonth()];
    const year = purchasedAtDate.getFullYear();

    return `${day} ${month} ${year}`;
};
 
 
let ltd = "LTD “Auto Import Georgia”"
let sk = "406203120"
let email = "Email: info@aig.com.ge" 
let tel = "TEL: +995 322 11 12 13; +995 591 29 60 60" 
let address = "Ts. Dadiani str. 123/125, 0180 Tbilisi, Georgia"  
 

Font.register({
    family: 'HelveticaRd',  
    src: HelveticaRd, 
});

Font.register({
    family: 'HelveticaBold', 
    src: HelveticaBold, 
});
 

Font.register({
    family: 'FontLetter', 
    src: FontLetter, 
});
 
  
const styles = StyleSheet.create({

    page: {
        fontFamily: 'HelveticaRd', 
        backgroundColor: '#FFF',
        padding: '30px',
        paddingTop: '30px',
        fontSize: '10px',
        lineHeight: 1.2,  
    },  
    b: { 
        fontFamily: 'HelveticaBold', 
    }, 
    FontLetter: { 
        fontFamily: 'FontLetter'
    }, 

});
 
   
 
const MyDocument = ({ container, cargo }) => {
     
     

    return (
    <Document>

        <Page size="A4" style={styles.page}>


            <View style={{  flexDirection: "row", marginBottom: 20}}> 
                <View style={{ width: '50%' }}>  
                    <Image src={AigLogo} style={{ marginTop: '25px', width: '140px', height: 'auto' }} />
                </View>

                <View style={{ width: '50%', border: "1px solid #555",}}> 

                    <View style={{ width: '100%', borderBottom: "1px solid #555"}}>  
                        <Text style={{ width: '100%', padding: '5px', backgroundColor: '#ebebeb', textAlign: 'left', fontSize: '11px', fontFamily: 'HelveticaBold', textTransform: 'uppercase' }}>
                            {ltd}
                        </Text>
                    </View>  
    
                    <View style={{  flexDirection: "row", borderBottom: "1px solid #555"}}> 
                        <View style={{ width: '100%'}}>  
                            <Text style={{ width: '100%', padding: "5px", backgroundColor: '#fff'  }}> I/C: { sk }</Text>
                        </View> 
                    </View>
                        
                    <View style={{  flexDirection: "row", borderBottom: "1px solid #555"}}> 
                        <View style={{ width: '100%'}}>  
                            <Text style={{ width: '100%', padding: "5px", backgroundColor: '#fff'  }}>{ address }</Text>
                        </View> 
                    </View>
                    
                    <View style={{  flexDirection: "row", borderBottom: "1px solid #555"}}> 
                        <View style={{ width: '100%'}}>  
                            <Text style={{ width: '100%', padding: "5px", backgroundColor: '#fff',  }}>{ tel }</Text>
                        </View> 
                    </View>
                    
                    <View style={{  flexDirection: "row" }}> 
                        <View style={{ width: '100%'}}>  
                            <Text style={{ width: '100%', padding: "5px", backgroundColor: '#fff',  }}>{ email }</Text>
                        </View> 
                    </View>
   
                </View>
            </View>
 
 
            <View style={{ width: '100%', textAlign: 'center', marginBottom: '3px', marginTop: '15px'}}>  
                <Text style={{ fontFamily: 'HelveticaBold', fontSize: '14px', textTransform: 'uppercase' }}>
                    Invoice No: {container.id}/{cargo.id}
                </Text>
            </View>   
            
            <View style={{  width: '100%', marginBottom: '5px', textAlign: 'center', }}>  
                <Text>{ formatDate(container.send_at) || '- - -'} </Text>
            </View>  
            
   

 


            <View style={{ width: '100%', border: "1px solid #555",   marginTop: '10px'}}> 
                <View style={{  flexDirection: "row" }}> 
                    <View style={{ width: '31%'}}>
                        <Text style={{ padding: "5px", backgroundColor: '#ebebeb', borderRight: "1px solid #555" }}>CAR DETAILS</Text>
                    </View>
                    <View style={{ width: '21%'}}>  
                        <Text style={{ padding: "5px", backgroundColor: '#ebebeb', borderRight: "1px solid #555" }}>CAR OWNER</Text>
                    </View> 
                    <View style={{ width: '15%'}}>  
                        <Text style={{ padding: "5px", backgroundColor: '#ebebeb', borderRight: "1px solid #555" }}>CONTAINER</Text>
                    </View> 
                    <View style={{ width: '15%', padding: "5px", backgroundColor: '#ebebeb',borderRight: "1px solid #555"}}>  
                        <Text>TRANSPORT</Text>
                    </View> 
                    <View style={{ width: '9%',  padding: "5px", backgroundColor: '#ebebeb',borderRight: "1px solid #555"}}>  
                        <Text>PRICE</Text>
                    </View> 
                    <View style={{ width: '9%',  padding: "5px", backgroundColor: '#ebebeb'}}>  
                        <Text>PAID</Text>
                    </View> 
                </View>

  
                    <View style={{ display: 'flex', alignItems: 'stretch', flexDirection: "row" , borderTop: "1px solid #555"}}> 
                        <View style={{ width: '31%', borderRight: "1px solid #555", padding: '5px' }}>
                            <Text>{cargo.car_info}</Text>
                            <Text>{cargo.vin}</Text>
                        </View>
                        <View style={{ width: '21%',  padding: "5px", borderRight: "1px solid #555" }}>  
                            <Text>{cargo.name || ''} </Text>
                            <Text>ID: { cargo.personal } </Text>
                        </View> 
                        <View style={{ width: '15%',  padding: "5px", borderRight: "1px solid #555" }}>  
                            <Text>{ container.container_number } </Text>
                        </View> 
                        <View style={{ width: '15%',  padding: "5px", borderRight: "1px solid #555"}}>  
                            <Text>
                            { container && container.sender_country && container.sender_country.code ? (
                                <>{container.sender_city.name}, {container.sender_country.code}</>
                            ) : null  }
                            </Text>
                            <Text>
                            { container && container.reciever_country && container.reciever_country.code ? (
                                <>{container.reciever_city.name }, {container.reciever_country.code}</>
                            ) : null  }
                            </Text> 
                        </View> 
                        <View style={{ width: '9%',  padding: "5px",fontFamily: 'HelveticaBold', borderRight: "1px solid #555"}}>  
                            <Text>{cargo.cargo_price || '0'} $</Text>
                        </View> 
                        <View style={{  width: '9%', fontFamily: 'HelveticaBold',  padding: "5px"}}>  
                            <Text>{cargo.cargo_price - cargo.total_debt} $</Text>
                        </View>
                        
                    </View>
                

                <View style={{ display: 'flex', alignItems: 'stretch', flexDirection: "row" , borderTop: "1px solid #555"}}> 
                    <View style={{ width: '82%', borderRight: "1px solid #555", padding: '5px', textAlign: 'right' }}>
                        <Text>SUM</Text> 
                    </View>
                   
                    <View style={{ width: '9%',  padding: "5px",fontFamily: 'HelveticaBold', borderRight: "1px solid #555"}}>  
                        <Text>{cargo.cargo_price || '0'} $</Text>
                    </View> 
                    <View style={{  width: '9%', fontFamily: 'HelveticaBold',  padding: "5px"}}>  
                        <Text>{cargo.cargo_price - cargo.total_debt} $</Text>
                    </View>
                </View>

                <View style={{ display: 'flex', alignItems: 'stretch', flexDirection: "row" , borderTop: "1px solid #555"}}> 
                    <View style={{ width: '100%', padding: '5px', fontFamily: 'HelveticaBold', fontSize: '12px', textAlign: 'center' }}>
                        <Text>მიმდინარე დავალიანება / Balance Due {cargo.total_debt} USD</Text> 
                    </View> 
                </View>

 
            </View> 





            <View style={{ width: '100%', border: "1px solid #555", borderBottom: "none", marginTop: '30px'}}> 
  
                    <View style={{ width: '100%', borderBottom: "1px solid #555"}}>  
                        <Text style={{ width: '100%', padding: '5px', backgroundColor: '#ebebeb', textAlign: 'center', fontFamily: 'HelveticaBold', textTransform: 'uppercase' }}>
                        Wire Instruction
                        </Text>
                    </View>  


                    <View style={{  flexDirection: "row" , borderBottom: "1px solid #555"}}> 
                        <View style={{ width: '15%'}}>
                            <Text style={{ width: '100%', padding: "5px", backgroundColor: '#ebebeb', borderRight: "1px solid #555" }}>Bank Name:</Text>
                        </View>
                        <View style={{ width: '35%'}}>  
                            <Text style={{ width: '100%', padding: "5px", backgroundColor: '#fff', borderRight: "1px solid #555", fontFamily: 'HelveticaBold'}}>{ 'Bank of Georgia' }</Text>
                        </View> 
                        <View style={{ width: '15%'}}>
                            <Text style={{ width: '100%', padding: "5px", backgroundColor: '#ebebeb', borderRight: "1px solid #555" }}>Bank Name:</Text>
                        </View>
                        <View style={{ width: '35%'}}>  
                            <Text style={{ width: '100%', padding: "5px", backgroundColor: '#fff', fontFamily: 'HelveticaBold' }}>{ 'JSC TBC BANK' }</Text>
                        </View> 
                    </View>


                    <View style={{  flexDirection: "row" , borderBottom: "1px solid #555"}}> 
                        <View style={{ width: '15%'}}>
                            <Text style={{ width: '100%', padding: "5px", backgroundColor: '#ebebeb', borderRight: "1px solid #555" }}>Bank Swift:</Text>
                        </View>
                        <View style={{ width: '35%'}}>  
                            <Text style={{ width: '100%', padding: "5px", backgroundColor: '#fff', borderRight: "1px solid #555"}}>{ 'BAGAGE22' }</Text>
                        </View> 
                        <View style={{ width: '15%'}}>
                            <Text style={{ width: '100%', padding: "5px", backgroundColor: '#ebebeb', borderRight: "1px solid #555" }}>Bank Swift:</Text>
                        </View>
                        <View style={{ width: '35%'}}>  
                            <Text style={{ width: '100%', padding: "5px", backgroundColor: '#fff' }}>{ 'TBCBGE22' }</Text>
                        </View> 
                    </View>


                    <View style={{  flexDirection: "row" , borderBottom: "1px solid #555"}}> 
                        <View style={{ width: '15%'}}>
                            <Text style={{ width: '100%', padding: "5px", backgroundColor: '#ebebeb', borderRight: "1px solid #555" }}>Accaunt #</Text>
                        </View>
                        <View style={{ width: '35%'}}>  
                            <Text style={{ width: '100%', padding: "5px", backgroundColor: '#fff', borderRight: "1px solid #555"}}>{ 'GE19BG0000000131217994 GEL/USD' }</Text>
                        </View> 
                        <View style={{ width: '15%'}}>
                            <Text style={{ width: '100%', padding: "5px", backgroundColor: '#ebebeb', borderRight: "1px solid #555" }}>Accaunt #</Text>
                        </View>
                        <View style={{ width: '35%'}}>  
                            <Text style={{ width: '100%', padding: "5px", backgroundColor: '#fff' }}>{ 'GE54TB7734536020100004 GEL' }</Text>
                        </View> 
                    </View>

   
                </View> 

                <View style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', position: 'relative'}}>  
                    <Image src={Signature} style={{ position: 'absolute', right: '40px', top: '0',  marginTop: '25px', width: '240px', height: 'auto' }} />
                </View>

 
        </Page>
 
    </Document>
    ); 
};
const InvoiceCargo = ({ defaultContainer, defaultCargo, cargoWeight }) => {
  
    const generatePDF = async () => {
        const blob = await pdf(<MyDocument cargo={defaultCargo} cargoWeight={cargoWeight} container={defaultContainer} />).toBlob();
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.target = '_blank';
        // link.download = 'invoice.pdf';
        link.click();
    };

    return (
        <span style={{ cursor: 'pointer', display: 'flex', color:' var(--secondary-text-color)', }} onClick={generatePDF}>  <FileDollar  /> </span>
    );
};

export default InvoiceCargo; 